import { makeAutoObservable } from 'mobx';

export interface IDataStore<Entity> {
  get data(): Entity;

  setData(data: Entity): void;
  setData(data: (data: Entity) => Entity): void;

  selector<T>(fn: (data: Entity) => T): T;
}

export class DataStore<Entity> implements IDataStore<Entity> {
  private _data: Entity;

  get data(): Entity {
    return this._data;
  }

  constructor(initialState: Entity) {
    this._data = initialState;

    makeAutoObservable(this);
  }
  selector<T>(fn: (data: Entity) => T): T {
    const result = fn(this._data);

    return result;
  }

  setData(data: Entity): void;
  setData(data: (data: Entity) => Entity): void;
  setData(data: any): void {
    if (typeof data === 'function') {
      const result = data(this._data);
      this._data = result;
      return;
    }

    this._data = data;
  }
}
